import { ControlledCheckbox } from '@if/mui'
import { Box, Stack, Typography } from '@mui/material'
import { BannerDto } from '@src/data/types/BannerSchema'
import { memo } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<BannerDto>
}

const BannerPropertiesPanel = ({ control }: Props) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t('merchant.properties')}
      </Typography>
      <Stack gap={1}>
        <ControlledCheckbox
          name="worksheetByMerchant"
          control={control}
          label={
            <Box>
              <Typography>{t('merchant.worksheetByMerchant.title')}</Typography>
              <Typography variant="body2" color="text.secondary">
                {t('merchant.worksheetByMerchant.description')}
              </Typography>
            </Box>
          }
        />
      </Stack>
    </Box>
  )
}

export default memo(BannerPropertiesPanel)
